import classNames from 'classnames';
import React from 'react';

type Variant = 'new' | 'positive' | 'request' | 'negative' | 'neutral';

export type InsightsLabelProps = {
  variant: Variant;
  text?: string;
};

export const InsightsLabel: React.FC<InsightsLabelProps> = ({
  variant,
  text,
}) => {
  const defaultClasses = [
    'text-xs lg:text-base px-1 py-4px rounded-4px inline-block uppercase flex-nowrap',
  ];

  const variantClasses = {
    new: 'bg-teal-100 text-white',
    positive: 'bg-teal-100 text-white',
    request: 'bg-orange-100 text-text1',
    negative: 'bg-red-100 text-white',
    neutral: 'bg-grey-300 text-text1',
  }[variant];

  return variant === 'neutral' ? (
    <div className={classNames(defaultClasses, variantClasses)}>{text}</div>
  ) : (
    <div className={classNames(defaultClasses, variantClasses)}>{variant}</div>
  );
};
